import type { uuid } from "@/interfaces";
import { CONTACT_PROPERTIES_TITLE } from "@/lib/property-contact-scope";
import { ContactAppointmentsTable } from "./appointments-table";
import { useMyContactProperties } from "./contact.hooks";

type Props = { note: string; appointmentHref?: (appointment: uuid) => string };

export function ContactPropertyAppointments({ note, appointmentHref }: Props) {
  const { value: properties } = useMyContactProperties();
  if (!properties?.length) return null;

  return (
    <section aria-label={CONTACT_PROPERTIES_TITLE} className="mt-8 space-y-4">
      <div>
        <h2 className="text-lg font-semibold">{CONTACT_PROPERTIES_TITLE}</h2>
        <p className="text-sm text-muted-foreground">{note}</p>
      </div>
      {properties.map((property) => (
        <ContactAppointmentsTable key={property.id} property={property.id} title={property.name} description="Appointments at a property you're a contact for" appointmentHref={appointmentHref} />
      ))}
    </section>
  );
}
